export { build_tracker_document } from "./signing_tracker_recipient_helpers";

export function parse_positive_number(value) {
    const parsed = Number(value || 0);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export function update_summary_count(summary, status) {
    if (status.includes("completed")) {
        summary.signed += 1;
        return summary;
    }

    if (status.includes("opened")) {
        summary.viewed += 1;
        return summary;
    }

    summary.pending += 1;
    return summary;
}
